<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		{{title}}
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
	</div>
</div>

<div id="{{objectIdForCollapsingWidget}}" *ngIf="!toggled" [hidden]="toggled" class="jmWidgetPadding">
	<div class="w-100" style="height:6%">
		<div class="jmPageTitle" style="padding-bottom: 10px;">
			{{title}}
			<div (click)="toggleCollapse()" *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="margin-top:10px;"></div>
			<i class="jmInfoCircle" style="vertical-align:middle" (click)="displayInfoWrapper('Test Scores','At schools that report their test scores, 50 percent had scores within this range. Of the remaining 50 percent, half were above the range and half were below. Not all schools require test scores.', 'testScore')"></i>
		</div>
	</div>
	<div style="margin-bottom:3px">Students who were admitted and enrolled typically has standardized test scores in these ranges.</div>
	<div>
		<div *ngFor="let testObj of data">
			<div style="margin-bottom:5px;" *ngIf="testObj.Type!=undefined && testObj.Type.length>0">{{testObj.Type}} <span style="padding-left:20px;" *ngIf="testObj.Lower===0 && testObj.Type==='ACT'">(Data not available)</span></div>
			<figure>
				<div>{{testObj.SubType}}<span style="padding-left:20px;" *ngIf="testObj.Lower===0 && testObj.Type!=='ACT'">(Data not available)</span></div>
				<picc-range [attr.max]="testObj.Max" [attr.lower]="testObj.Lower" [attr.upper]="testObj.Upper" style="font-size:11px">
					<div class="picc-range-bar" [ngStyle]="{'left':testObj.LowerPcnt+'%', 'right':(100-testObj.UpperPcnt)+'%'}" *ngIf="testObj.Lower>0"></div>
					<span class="picc-range-label picc-range-label-min" [ngStyle]="{'left':testObj.MinPcnt+'%'}"><span>{{testObj.Min}}</span></span>
					<span class="picc-range-label picc-range-label-max" [ngStyle]="{'left':testObj.MaxPcnt+'%'}"><span>{{testObj.Max}}</span></span>
					<span class="picc-range-label picc-range-label-lower" [ngStyle]="{'left':testObj.LowerPcnt+'%'}" *ngIf="testObj.Lower>0"><span>{{testObj.Lower}}</span></span>
					<span class="picc-range-label picc-range-label-middle" [ngStyle]="{'left':testObj.MiddlePcnt+'%'}" *ngIf="testObj.Lower>0"><span>{{testObj.Middle}}</span></span>
					<span class="picc-range-label picc-range-label-upper" [ngStyle]="{'left':testObj.UpperPcnt+'%'}" *ngIf="testObj.Lower>0"><span>{{testObj.Upper}}</span></span>
				</picc-range>
			</figure>
		</div>
	</div>
</div>
